// 気持ちの確認（仕様 5.5）。評価点・達成判定ではない。
// 選択に応じて「提案」を出すだけで、自動では何も実行しない（タスクの作成・ゴールの変更・削除をしない）。
import type { FutureFeeling } from "../../api/futureBoard";

// 提案の種類。画面は、これを押せるボタンとして出す（押されるまで何も起きない）。
export type FeelingSupport =
  | "view_scene"           // 気に入った場面や未来の自分を確認する
  | "talk_ai"              // 希望すれば AI と話す
  | "describe_role"        // 未来の自分の役割や振る舞いを、本人の言葉で描く
  | "explore_wish"         // 今の望みを探す
  | "edit_text"            // 文章を編集する
  | "keep_as_is"           // そのままにする
  | "record_only"          // 記録だけ残す
  | "leave_without_record"; // 何も残さず終える

export interface FeelingOption {
  /** 表示名は i18n（futureBoard.feeling.<key>） */
  key: FutureFeeling;
  supports: readonly FeelingSupport[];
}

export const FEELINGS: readonly FeelingOption[] = [
  { key: "anticipation", supports: ["view_scene", "talk_ai"] },
  { key: "distant", supports: ["describe_role"] },
  { key: "review", supports: ["explore_wish", "edit_text", "keep_as_is"] },
  { key: "unspoken", supports: ["record_only", "leave_without_record"] },
];

export const FEELING_KEYS: readonly FutureFeeling[] = FEELINGS.map(option => option.key);

export function supportsFor(feeling: FutureFeeling | null): readonly FeelingSupport[] {
  return FEELINGS.find(option => option.key === feeling)?.supports ?? [];
}

// 回答は任意。未回答のまま、その日の利用を終えられる。
export const ANSWER_IS_OPTIONAL = true;

export const MEMO_MAX = 400;

// 送る内容。未選択のときは null（何も記録しない）。前回の回答は引き継がない。
export function buildCheckinInput(feeling: FutureFeeling | null, memo: string): { feeling: FutureFeeling; memo?: string } | null {
  if (!feeling) return null;
  const text = memo.trim();
  return text ? { feeling, memo: text } : { feeling };
}

export const isMemoTooLong = (memo: string): boolean => [...memo.trim()].length > MEMO_MAX;
